import http from '../common/http'

export const GetOrderDetail = order => (
    http.post('/Order/Detail', order)
)
export const GetOrderList = filter =>(
  http.post('/OrderList/Get', filter)
)

export const UpdateOrderLinkman = order => (
    http.post('/Order/UpdateLinkMan', order)
)

export const UpdateOrderScheduledTime = order => (
    http.post('/Order/UpdateScheduledTime', order)
)

export const UpdateOrderItem = order => (
    http.post('/Order/UpdateOrderItem', order)
)

export const ReceivingOrder = order => (
    http.post('/Order/Receiving', order)
)

export const DismissedOrder = order => (
    http.post('/Order/Dismissed', order)
)

export const DiscardOrder = order => (
    http.post('/Order/Discard', order)
)

export const SettlementOrder = order => (
    http.post('/Order/Settlement', order)
)

export const CalcSettlementOrder = order => (
    http.post('/Order/CalcSettlement', order)
)

export const VerifyServiceCode = order => (
    http.post('/Order/VerifyServiceCode', order)
)

export const InitiatePayment = order => (
    http.post('/Order/InitiatePayment', order)
)

export const OrderReceive = params =>(
    http.post('/OrderReceive/OrderReceive', params )
)

export const RefreshQRCode = params =>(
    http.post('/OrderReceive/RefreshQRCode', params )
)

export const GetServiceOrderDetailByServiceCode = params =>(
    http.post('/Order/DetailByServiceCode', params )
)

export const ForceReceivingServiceOrder = params =>(
    http.post('/Order/ForceReceiving', params )
)

export const GetCommentQRCode = params=>(
    http.post('/OrderReceive/GetCommentQRCode', params )
)
export const GetImgVerifyCodeBySign = params =>(
	http.get('/Account/GetImgVerifyCodeBySign',params)
);
export const ReSendServiceCode = params =>(
	http.post('/Order/ReSendServiceCode',params)
);

export const TakeMoneyReSendServiceCode = params =>(//收款页面重发服务码，无验证码版本
	http.post('/Order/TakeMoneyReSendServiceCode',params)
);
export const GetProductBySkuCode = params =>(//改换整屏 - 根据sku编码获取商品
	http.post('/Order/GetProductBySkuCode',params)
);

export const GetOneCode = code =>(//查询一物一码
	http.get('/Order/GetOneCode',{code: code})
);

export const CreateOrder= params =>(//创建订单
	http.post('/Order/CreateOrderByScanCode',params)
);

export const InsideCodeQueryQualityAssurance= params =>(//内码查质保
	http.post('/Order/InsideCodeQueryQualityAssurance',params)
);

export const UpdateRepairRemark= params =>(//更新订单备注remark
	http.post('/Order/UpdateRepairRemark',params)
);

export const DiscardAgentOrder= params =>( //代修订单作废
    http.post('/AgentRepair/DiscardOrder', params)
);

export const BackRepairing = params =>( // 待收款回退维修中
    http.post('/Order/WaitPayBackRepairing', params)
);

export const BackRepairingReason = params =>( // 待收款回退维修中
    http.post('/Order/BackRepairingReason', params)
);
export const CareOrderVervify = params =>( // 无忧卡订单IMEI校验
	http.post('/Order/CareOrderVervify', params)
);

export const AddBatteryServiceSurvey = params =>( // 添加电芯维修能力调查记录
	http.post('/Order/AddBatteryServiceSurvey', params)
);

export const IsExistSurvey = params =>( // 是否存在电芯维修能力调查记录
	http.post('/Order/IsExistSurvey', params)
);

export const GetSuveryedShopNoList = params =>( // 获取已完成调研的门店列表
	http.post('/Order/GetSuveryedShopNoList', params)
);

export const DouYinCertificatePrepare = params =>( // 抖音验券准备
	http.post('/Order/DouYinCertificatePrepare', params)
);
export const DouYinVerifyCertificate = params =>( // 抖音验券
	http.post('/Order/DouYinVerifyCertificate', params)
);
export const GetDetailForReceiving = params =>( // 通过服务订单号获取订单明细--抖音来客订单认领
	http.post('/Order/GetDetailForReceiving', params)
);
export const ActivateQAByPhoto = params => ( // 激活一物一码码通过照片
		http.post('/YunMaWarranty/ActivateQAByPhoto', params)
);

export const GetActivateQA = params => ( // 查询激活信息
		http.post('/YunMaWarranty/GetActivateQA', params)
);

export const KsCertificatePrepare = params => ( // 快手验券准备
		http.post('/Order/KsCertificatePrepare', params)
);

export const KsCertificateVerify = params => ( // 快手验券
		http.post('/Order/KsCertificateVerify', params)
);



// WEBPACK FOOTER //
// ./src/api/orderApi.js